var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66671 10H4.00004C3.2928 10 2.61452 10.281 2.11442 10.781C1.61433 11.2811 1.33337 11.9594 1.33337 12.6667V14M14.4667 10.9334L13.8667 10.7334M10.1334 9.26673L9.53341 9.06673M11.0668 12.4667L11.2668 11.8667M12.7334 8.13337L12.9334 7.53337M13.0667 12.4666L12.8 11.8M11.2 8.20003L10.9333 7.53337M9.53341 11.0666L10.2001 10.8M13.8 9.19994L14.4667 8.93327M14 10C14 11.1046 13.1046 12 12 12C10.8955 12 10 11.1046 10 10C10 8.89543 10.8955 8 12 8C13.1046 8 14 8.89543 14 10ZM8.66671 4.66667C8.66671 6.13943 7.4728 7.33333 6.00004 7.33333C4.52728 7.33333 3.33337 6.13943 3.33337 4.66667C3.33337 3.19391 4.52728 2 6.00004 2C7.4728 2 8.66671 3.19391 8.66671 4.66667Z",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCog);
export default __webpack_public_path__ + "static/media/user-cog.ac4ef4ba8514d25dc223bb087259838a.svg";
export { ForwardRef as ReactComponent };